import { render, staticRenderFns } from "./AddEditService.vue?vue&type=template&id=47fa5c91&"
import script from "./AddEditService.vue?vue&type=script&lang=js&"
export * from "./AddEditService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports